import LinkHref from 'components/LinkHref';
import NavDropdown from 'components/NavDropdown';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import MediaQuery from 'react-responsive';
import { activeLink, hasDropdownC, link as linkC, mobileDropdown } from './ProductNav.module.scss';

const HoverMenuButton = ({ dropdownData, text, link, notificationIsShown}) => {
  const [dropdownIsOpen, setDropdown] = useState(false);
  return (
    <div style={{ 'position': 'relative' }}>
      <MediaQuery minWidth={1025}>
        <div
          onMouseEnter={() => setDropdown(true)}
          onMouseLeave={() => setDropdown(false)}
          className={hasDropdownC}
        >
          <LinkHref
            className={linkC}
            activeClassName={activeLink}
            link={link}
            text={text}
            partiallyActive={true}
          />
          <NavDropdown
            isOpen={dropdownIsOpen}
            notificationIsShown={notificationIsShown}
            data={dropdownData}
          />
        </div>
      </MediaQuery>
      <MediaQuery maxWidth={1024}>
        <div
          onClick={() => setDropdown(!dropdownIsOpen)}
          className={hasDropdownC}
        >
          <div className={linkC}>{text}</div>
        </div>
      </MediaQuery>
      <MediaQuery maxWidth={1024}>
        <NavDropdown
          isOpen={dropdownIsOpen}
          notificationIsShown={notificationIsShown}
          data={dropdownData}
          className={mobileDropdown}
        />
      </MediaQuery>
    </div>
  )
};

HoverMenuButton.propTypes = {
  text: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  notificationIsShown: PropTypes.bool.isRequired,
  dropdownData: PropTypes.array.isRequired,
};

export default HoverMenuButton;